<footer #footer class="page-footer font-small text-white pt-4">
  <div class="container text-center text-md-left">
    <div class="row">
      <div class="col-md-6 mt-md-0 mt-3">
        <h3 class="mb-0"><strong>Dirección</strong></h3>
        <p>
          Calle Ramón Galguera Noverola #106<br />Col. Reforma, Villahermosa,<br />Tabasco
          C.P. 86080
        </p>

        <h3 class="mb-0"><strong>Teléfono</strong></h3>
        <p>01 993 315 49 62</p>
      </div>

      <hr class="clearfix w-100 d-md-none pb-3" />

      <div class="col-md-6 mt-md-5">
        <div
          class="d-flex flex-row justify-content-center align-items-center text-center"
        >
          <div class="equalHW align-self-center">
            <a
              href="https://www.fcarm.org.mx/"
              target="blank"
              title="FCARM"
              rel="home"
            >
              <img src="assets/img/fcarm.png" alt="FCARM" class="logos" />
            </a>
          </div>
          <div class="equalHW align-self-center">
            <a
              href="https://www.fcarm.org.mx/region-iii/"
              target="blank"
              title="Región III"
              rel="home"
            >
              <img src="assets/img/LOGO V2.png" alt="FCARM" class="logos" />
            </a>
          </div>
          <div class="equalHW align-self-center">
            <a
              href="https://www.uia-architectes.org/webApi/en/"
              target="blank"
              title="UIA"
              rel="home"
            >
              <img src="assets/img/uia.png" alt="FCARM" class="logos" />
            </a>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-4">
            <div class="shop-isle-header-title-inner text-center">
              <h1 class="site-title mb-0 text-white">
                <a href="https://www.fcarm.org.mx/" title="FCARM" rel="home">
                  <img
                    src="assets/img/FCARM_dark.png"
                    alt="FCARM"
                    height="95"
                  />
                </a>
              </h1>
            </div>
          </div>
          <div class="col-4">
            <div class="shop-isle-header-title-inner text-center">
              <h1 class="site-title mb-0 text-white">
                <a
                  href="https://www.fcarm.org.mx/region-iii/"
                  title="Región III"
                  rel="home"
                >
                  <img
                    src="assets/img/colegios_arquitectos_r3_small.png"
                    alt="FCARM"
                    height="40"
                  />
                </a>
              </h1>
            </div>
          </div>
          <div class="col-4">
            <div class="shop-isle-header-title-inner text-center">
              <h1 class="site-title mb-0 text-white">
                <a
                  href="https://www.uia-architectes.org/webApi/en/"
                  title="UIA"
                  rel="home"
                >
                  <img src="assets/img/UIA_small.png" alt="FCARM" height="50" />
                </a>
              </h1>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="footer-copyright text-center py-3">
    &copy; {{ currentDate | date: "yyyy" }} Colegio de Arquitectos Tabasqueños
    A.C.
  </div>
</footer>
